import dayjs from "dayjs";
import { connect } from "react-redux";
import { constant } from "../../../Utils/constants";
import StyledTable from "../../../../../commons/styles/table";

import { EditOutlined, CaretLeftOutlined } from "@ant-design/icons";
import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  message,
  Input,
  Checkbox,
  DatePicker,
  Form,
  Drawer,
  Button
} from "antd";
import {
  getRuleExecutionInfo,
  saveFeedback,
  getfeedBackInfo,
  updateFeedBack,
} from "../../../Utils/FormCalls";
import { StyledHomepage } from "../../../../../commons/styles/layout";

const { RangePicker } = DatePicker;

const CmFeedback = (props) => {
  const [tableData, setTableData] = useState([]);
  const [openModel, setOpenModel] = useState(false);
  const [feedBackInfo, setFeedBackInfo] = useState({});

  const [editFlag, setEditFlag] = useState(false);
  const [selectedDate, setSelectedDate] = useState({
    startDate: dayjs().subtract(1, 'hour').format('YYYY-MM-DD 00:00'),
    endDate: dayjs().format('YYYY-MM-DD 23:59')
  });
  const [translationCache] = useState(props.translationCache || []);
  const hRef = useRef();
  const currentPage = 1;

  useEffect(() => {
    getRuleHistory([dayjs().format('YYYY-MM-DD 00:00'), dayjs().format('YYYY-MM-DD 23:59')]);
  }, []);

  const getRuleHistory = async (date) => {
    let queryString = props.location.search;
    let ruleId = queryString.split('=')[1];
    if (ruleId) {
      let ruleStatuInfo = await getRuleExecutionInfo(ruleId, date);
      setTableData(ruleStatuInfo && ruleStatuInfo.data);
    }
  };

  const handleFeedbackEvents = (e, type) => {
    let updatedFeedBackInfo = { ...feedBackInfo };
    if (type === 'actions') {
      const { translationCache } = props;
      let translationAction;

      let keys = Object.keys(translationCache);

      let arrConverter = e.map((action) => {
        let data = keys.filter((labels) => {
          return translationCache[labels] === action;
        });
        return data[0] === undefined ? [action] : data;
      });
      translationAction = arrConverter.map((indexedArry) => {
        return indexedArry[0];
      });
      updatedFeedBackInfo['actions'] = translationAction;
    } else {
      updatedFeedBackInfo['comments'] = e.target.value;
    }
    setFeedBackInfo(updatedFeedBackInfo);
  };

  const handleModelCancel = () => {
    hRef.current.resetFields();
    setOpenModel(false);
  };

  const handleFeedbackSave = async () => {
    try {
      if (!editFlag) {
        await saveFeedback(feedBackInfo);
      } else {
        await updateFeedBack(feedBackInfo);
        setFeedBackInfo({});
      }
      setOpenModel(false);
    } catch (error) {
      message.error(error.response.data.message);
    }
  };

  // const handlePagination = (pageNumber) => {
  //   setCurrentPage(pageNumber.current);
  // };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const onChange = (value) => {
    getRuleHistory(value);
    setSelectedDate({
      startDate: dayjs(value[0]).format('YYYY-MM-DD HH:mm'),
      endDate: dayjs(value[1]).format('YYYY-MM-DD HH:mm')
    });
  };

  const disabledDate = (current) => {
    return current > dayjs().endOf('day');
  };

  const columns = [
    {
      title: translation(constant.sno),
      dataIndex: 'sno',
      render: (text, record, index) => {
        return (
          <span>
            {currentPage === 1 ? currentPage * (index + 1) : (currentPage - 1) * 10 + (index + 1)}
          </span>
        );
      }
    },
    {
      title: translation(constant.tagName),
      dataIndex: 'ParameterCode',
      key: 'ParameterCode',
      render: (text) => <span>{text}</span>
    },
    {
      title: translation(constant.tagValue),
      dataIndex: 'ParameterValue',
      key: 'ParameterValue',
      render: (text) => <span>{text}</span>
    },
    {
      title: translation(constant.communicationType),
      dataIndex: 'CommunicationType',
      key: 'CommunicationType'
    },
    {
      title: translation(constant.exeTime),
      dataIndex: 'CommunicationTime',
      key: 'CommunicationTime',
      render: (text) => <>{dayjs(text).format('YYYY-MM-DD HH:mm:ss')}</>
    },
    {
      title: translation(constant.fdBack),
      dataIndex: 'Feedback',
      key: 'Feedback',
      render: (text, record) => (
        <EditOutlined
          onClick={async () => {
            const updatedFeedBackInfo = {
              timeStamp: record.CommunicationTime,
              TagId: record.ParameterCode,
              Id: record.Id,
              actions: [],
              comments: record.comments ? record.comments : ''
            };
            let editFlag = false;
            try {
              let feedBackData = await getfeedBackInfo(record.Id);
              if (feedBackData.data.length > 0) {
                updatedFeedBackInfo.actions = feedBackData.data[0].Action;
                updatedFeedBackInfo.comments = feedBackData.data[0].Comments;
                editFlag = true;
              }
            } catch (error) {
              message.warning("Can't Fetch Feedback Info");
            }
            if (hRef.current) {
              hRef.current.setFieldsValue(updatedFeedBackInfo);
            }
            setOpenModel(true);
            setFeedBackInfo(updatedFeedBackInfo);
            setEditFlag(editFlag);
          }}
        />
      )
    }
  ];

  const formItemLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 14 }
  };

  return (
    <StyledHomepage>
      <div>
        <Button
          onClick={() => {
            props.navigate(-1);
          }}
        >
          <CaretLeftOutlined />
          {translationCache && translationCache[`${constant.goBack}`]
            ? translationCache[`${constant.goBack}`]
            : `${constant.goBack}`}
        </Button>
        <div>
          <RangePicker
            showTime={{ format: 'HH:mm' }}
            style={{ width: '300px', float: 'right', marginTop: '2%', marginBottom: '3%' }}
            format="YYYY-MM-DD HH:mm"
            value={[dayjs(selectedDate.startDate), dayjs(selectedDate.endDate)]}
            onChange={onChange}
            disabledDate={disabledDate}
          />
        </div>

        <StyledTable size="small"
          columns={columns}
          dataSource={tableData}
        />
        <Drawer
          title="FeedBack"
          closable
          centered
          width={800}
          open={openModel}
          footer={[
            <Button key="back" onClick={handleModelCancel}>
              {translationCache && translationCache[`${constant.cancel}`]
                ? translationCache[`${constant.cancel}`]
                : `${constant.cancel}`}
            </Button>,
            <Button
              key="submit"
              onClick={handleFeedbackSave}
              style={{ fontWeight: 700, marginLeft: '5px' }}
            >
              {editFlag
                ? translationCache && translationCache[`${constant.update}`]
                  ? translationCache[`${constant.update}`]
                  : `${constant.update}`
                : translationCache && translationCache[`${constant.save}`]
                  ? translationCache[`${constant.save}`]
                  : `${constant.save}`}
            </Button>
          ]}
          onClose={handleModelCancel}
        >
          <Form {...formItemLayout} ref={hRef} initialValues={feedBackInfo}>
            <Form.Item label={translation(constant.timeStamp)}>
              <Input
                readOnly
                value={
                  feedBackInfo
                    ? dayjs.utc(feedBackInfo.timeStamp, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                    : null
                }
              />
            </Form.Item>
            <Form.Item label={translation(constant.tagName)}>
              <Input readOnly value={feedBackInfo ? feedBackInfo.TagId : null} />
            </Form.Item>
            <Form.Item label={translation(constant.action)}>
              <Checkbox.Group
                options={feedBackInfo.actions || []}
                value={Array.isArray(feedBackInfo.actions) ? feedBackInfo.actions : [feedBackInfo.actions]}
                onChange={(e) => handleFeedbackEvents(e, 'actions')}
              />
            </Form.Item>
            <Form.Item label={translation(constant.comment)}>
              <Input.TextArea
                value={feedBackInfo.comments}
                onChange={(e) => handleFeedbackEvents(e)}
              />
            </Form.Item>
          </Form>
        </Drawer>
      </div>
    </StyledHomepage>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
  };
};

export default connect(mapStateToProps)(CmFeedback);